import React, { createContext, useContext, useState } from 'react'

export type Lang = 'zh' | 'en'

const strings: Record<Lang, Record<string, string>> = {
  zh: {
    // App
    appTitle: 'CS 工作量看板',
    langToggle: '英文',
    // Font & theme chrome
    fontSizeLabel: '字体大小',
    fontStandard: '标准',
    fontLarge: '大',
    fontXlarge: '超大',
    themeLight: '浅色',
    themeGreen: '护眼绿',
    // Nav tabs
    navPersonalTasks: '个人任务',
    navMyPerformance: '个人效能',
    navOverview: '核心概览',
    navRegional: '区域透视',
    navLeaderboard: '效能榜单',
    navDataMgmt: '数据管理',
    navNoncompliant: '非标记录',
    navAssignments: '任务分派',
    navDutySchedule: '排班管理',
    navQuarterlyReport: '季度报表',
    navGlobalSearch: '全局查询',
    navPersonnel: '人员管理',
    navTaskDict: '任务字典',
    navAdminConsole: 'Admin 控制台',
    navAuditLog: '审计日志',
    // Notifications
    notifications: '通知',
    notifEmpty: '暂无通知',
    notifTaskAssigned1: '新分派任务：{title}',
    notifTaskAssignedN: '新分派了 {n} 个任务',
    notifTaskWithdrawn: '任务已撤回：{title}',
    notifTaskReassigned: '任务已改派：{title}',
    notifTaskOverdue: '任务逾期未完成：{title}',
    notifNoncompliantCreated: '有工作记录变为非标',
    notifGeneric: '您有一条新通知',
    // Audit log
    auditFilterEntityType: '按实体类型筛选',
    auditClearFilter: '清除筛选',
    auditTotal: '总计',
    auditTime: '时间',
    auditActor: '操作人',
    auditActorRole: '角色',
    auditAction: '操作',
    auditEntityType: '实体类型',
    auditEntityId: '实体 ID',
    auditDiff: '变更',
    auditNoEntries: '暂无审计记录',
    // Time range
    timeRangeThisWeek: '本周',
    timeRangeThisMonth: '本月',
    timeRangeLastMonth: '上月',
    timeRangeThisQuarter: '本季度',
    timeRangeCustom: '自定义',
    timeRangeFrom: '开始日期',
    timeRangeTo: '结束日期',
    // Auth
    logout: '退出登录',
    login: '登录',
    loginTitle: '登录',
    loginAccount: '邮箱或用户名',
    loginPassword: '密码',
    loginSubmit: '登录',
    loginRemember: '保持登录',
    forgotPassword: '忘记密码？',
    forgotPasswordTitle: '重置密码',
    forgotPasswordSubmit: '发送重置邮件',
    forgotPasswordSent: '如果该邮箱已注册，您将收到密码重置邮件（1 小时内有效）。',
    resetPasswordTitle: '设置新密码',
    resetPasswordSubmit: '确认重置',
    resetPasswordSuccess: '密码重置成功，即将跳转登录页…',
    backToLogin: '返回登录',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    oldPassword: '当前密码',
    myAccount: '我的账户',
    basicInfo: '基本信息',
    displayName: '显示名',
    username: '用户名',
    email: '邮箱',
    role: '角色',
    region: '区域',
    group: '小组',
    changePassword: '修改密码',
    saveChanges: '保存更改',
    profileSaved: '已保存',
    sessions: '会话管理',
    logoutOthers: '登出其他所有设备',
    logoutOthersDone: '已登出其他设备',
    errorLoginFailed: '登录失败，请检查账号和密码',
    errorLocked: '账号已锁定，请稍后重试或重置密码',
    errorGeneric: '操作失败，请重试',
    errorPasswordMismatch: '两次输入的密码不一致',
    errorPasswordEmpty: '密码不能为空',
    errorInvalidResetLink: '重置链接无效，请重新申请',
    // Task Dictionary
    taskDictAddTask: '添加任务',
    taskDictTaskName: '任务名称',
    taskDictCountingRule: '计数规则',
    taskDictReportAlias: '报表别名（可选）',
    taskDictIncludeInReport: '纳入报表',
    taskDictRegionScope: '区域范围',
    taskDictRegionBoth: '全部',
    taskDictRegionCnOnly: '仅中国',
    taskDictRegionUsOnly: '仅美国',
    taskDictSoftDelete: '存档',
    taskDictHardDelete: '删除',
    taskDictEdit: '编辑',
    taskDictSave: '保存',
    taskDictCancel: '取消',
    taskDictActive: '启用中',
    taskDictInactive: '已停用',
    taskDictShowInactive: '显示已停用任务',
    taskDictHardDeleteTitle: '删除任务',
    taskDictHardDeleteBody: '过去 90 天有 {N} 条引用。历史记录将标为非标（红色）但仍计入统计，无需重审。',
    taskDictHardDeleteInput: '输入任务名称以确认',
    taskDictHardDeleteConfirm: '确认删除',
    taskDictDuplicateName: '同分类下已有同名任务',
    taskDictCountingRuleHint: '立即作用于录入提示，不改历史记录',
    taskDictReadOnly: '只读',
    // Personnel
    personnelInvite: '邀请成员',
    personnelMembers: '成员列表',
    personnelPendingInvitations: '待处理邀请',
    personnelShowDeactivated: '显示已停用成员',
    personnelGroupLead: '组长',
    personnelStatus: '状态',
    personnelActions: '操作',
    personnelExpiresAt: '过期时间',
    personnelSetLead: '设组长',
    personnelUnsetLead: '卸组长',
    personnelTransfer: '调组/区',
    personnelBatchTransfer: '批量调组',
    personnelBatchTransferCount: '将调整 {n} 名成员的组别/区域',
    personnelDeactivate: '停用',
    personnelDeactivateConfirm: '确认停用该成员？停用后该成员将无法登录。',
    personnelReactivate: '恢复',
    personnelReactivateConfirm: '确认恢复该成员账号？',
    personnelUnlock: '解锁',
    personnelResendInvite: '重发邀请',
    personnelResend: '重发',
    personnelRevoke: '撤销',
    personnelCancelAccount: '注销',
    personnelCancelWarning: '此操作不可逆，注销后账号数据将被永久删除。',
    personnelCancelNameConfirm: '请输入显示名"{name}"以确认',
    personnelCancelReason: '注销原因',
    personnelCancelConfirm: '确认注销',
    personnelSetLeadWarning: '{name} 当前是本组组长，设置新组长后其组长身份将自动移除。',
    personnelCancel: '取消',
    personnelConfirm: '确认',
    personnelSubmit: '发送邀请',
    // Activate
    activateTitle: '激活账号',
    activateSubtitle: '请设置您的用户名和密码',
    activateUsername: '用户名',
    activateUsernamePlaceholder: '3-32位，字母/数字/下划线',
    activateUsernameHint: '用户名为3-32位，只能包含字母、数字和下划线',
    activateUsernameInvalid: '用户名格式不正确（3-32位，字母/数字/下划线）',
    activateSubmit: '激活账号',
    activateError: '激活失败，链接可能已过期或已使用',
    activateTokenMissing: '激活链接无效',
    activateSuccess: '账号激活成功，请登录。',
    // Admin Console
    adminTabRoles: '角色管理',
    adminTabScope: '可见范围',
    adminTabSysConfig: '系统配置',
    adminInviteManager: '邀请 Manager',
    adminInviteMember: '邀请 Member',
    adminPendingMemberInvitations: '待激活 Member 邀请',
    adminMemberName: '姓名',
    adminMemberEmail: '邮箱',
    adminMemberRole: '角色',
    adminMemberGroup: '小组',
    adminMemberStatus: '状态',
    adminActions: '操作',
    adminPromote: '升为 Manager',
    adminDemote: '降为 Member',
    adminDeactivate: '停用',
    adminPromoteConfirm: '确认将 {name} 升级为 Manager？',
    adminDemoteTitle: '降级为 Member',
    adminDemoteBody: '请输入 {name} 的显示名以确认降级',
    adminDemoteInput: '显示名',
    adminDemoteConfirm: '确认降级',
    adminDeactivateConfirm: '确认停用 {name}？停用后该成员将无法登录。',
    adminScopeTitle: '配置 Manager 可见范围',
    adminScopeSave: '保存范围',
    adminScopeAllGroups: '全部组（不限制）',
    adminSysConfigTitle: '系统配置',
    adminSysConfigSave: '保存配置',
    adminSysConfigAccessTtl: 'Access Token 有效期（分钟）',
    adminSysConfigRefreshTtl: 'Refresh Token 有效期（天）',
    adminSysConfigLockoutThreshold: '登录失败锁定阈值（次）',
    adminSysConfigLockoutMinutes: '锁定时长（分钟）',
    adminSysConfigBackupTime: '备份时刻（HH:MM）',
    adminSysConfigRetentionDays: '数据保留天数',
    adminSysConfigSaved: '配置已保存',
    adminAuditLink: '查看审计日志全集',
    adminPendingInvitations: '待激活邀请',
    adminNoManagers: '暂无 Manager',
    adminNoMembers: '暂无成员',
    // Work Log Form (T012)
    wlFormTitle: '新增工作记录',
    wlFormOpen: '记录',
    wlFormCategory: '分类',
    wlFormTask: '任务',
    wlFormTaskCustom: '任务名称（可自定义）',
    wlFormTaskPlaceholder: 'Slack and email follow-up',
    wlFormCountingRule: '计数规则：{rule}',
    wlFormDate: '日期',
    wlFormVolume: '处理量',
    wlFormHours: '工时（如 1.5h 或 90m）',
    wlFormNote: '备注（≤200字）',
    wlFormRegistrant: '登记人',
    wlFormSubmit: '提交',
    wlFormCancel: '取消',
    wlFormSuccess: '工作记录已提交',
    wlFormErrorAdmin: 'Admin 不能作为登记人',
    wlFormDateFuture: '日期超出今天+7天，确认提交？',
    wlFormDateOld: '日期早于今天-90天，确认提交？',
    wlFormSelectTask: '请从字典选择任务',
    wlFormSelectCategory: '请选择分类',
    wlFormSelectRegistrant: '请选择登记人',
    // Overview (T013)
    overviewTotalVolume: '总处理件数',
    overviewTotalHours: '总投入工时',
    overviewAvgThroughput: '平均产出率',
    overviewNoncompliant: '非标记录',
    overviewTotalMembers: '总成员数',
    overviewNoncompliantUnit: '条',
    overviewNoncompliantHint: '点击查看详情',
    overviewDonutTitle: '处理量分布（按分类）',
    overviewBarTitle: 'CN/US 消息量 & 工时',
    overviewBarMessages: '消息量',
    overviewBarHours: '工时',
    overviewForbidden: '仅 Manager 和 Admin 可访问概览页',
    overviewNoData: '暂无数据',
    // Regional Pivot (T014)
    regionalBarTitle: '各组处理量分布（按分类堆叠）',
    regionalCNTitle: '中国区（CN）成员明细',
    regionalUSTitle: '美国区（US）成员明细',
    regionalMember: '成员',
    regionalVolume: '处理量',
    regionalHours: '工时',
    regionalThroughput: '产出率',
    regionalTotal: '合计',
    regionalForbidden: '仅 Manager 和 Admin 可访问区域透视页',
    regionalNoData: '暂无数据',
    // Noncompliant Records (T015)
    noncompliantForbidden: '仅 Manager 和 Admin 可访问非标记录页',
    noncompliantRegionFilter: '区域',
    noncompliantRegionAll: '全部区域',
    noncompliantInfoBanner: '此视图列出因任务硬删而产生的非标记录（只读）。非标记录的 volume 仍计入产出率统计。',
    noncompliantTotal: '共',
    noncompliantNoRecords: '暂无非标记录',
    noncompliantColDate: '日期',
    noncompliantColMember: '登记人',
    noncompliantColRegion: '区域',
    noncompliantColGroup: '小组',
    noncompliantColCategory: '分类',
    noncompliantColTask: '任务',
    noncompliantColVolume: '处理量',
    noncompliantColHours: '工时',
    noncompliantColNote: '备注',
    noncompliantColStatus: '合规状态',
    noncompliantStatusLabel: '非标',
    // Leaderboard (T016)
    leaderboardForbidden: '仅 Manager 和 Admin 可访问效能榜单',
    leaderboardTaskFilter: '任务筛选',
    leaderboardPresets: '预设',
    leaderboardNoData: '暂无榜单数据',
    leaderboardColRank: '排名',
    leaderboardColMember: '成员',
    leaderboardColRegion: '区域',
    leaderboardColGroup: '小组',
    leaderboardColVolume: '处理量',
    leaderboardColHours: '工时',
    leaderboardColRecords: '记录数',
    leaderboardGroupLead: '组长',
    leaderboardTasksIncluded: '任务计入',
    leaderboardSelectAll: '全选',
    leaderboardDeselectAll: '全部取消',
    leaderboardPresetSave: '保存预设',
    leaderboardPresetSaved: '预设已保存',
    leaderboardPresetLoad: '应用',
    leaderboardPresetDelete: '删除',
    leaderboardPresetDeleteConfirm: '确认删除此预设？',
    leaderboardNoPresets: '暂无预设',
    leaderboardPresetNamePlaceholder: '预设名称',
    // Data Management (T017)
    dmForbidden: '仅 Manager 和 Admin 可访问数据管理页',
    dmKeyword: '关键字',
    dmKeywordPlaceholder: '搜索任务名...',
    dmKeywordActive: '关键字',
    dmSearch: '搜索',
    dmRegistrant: '登记人',
    dmAllMembers: '全部登记人',
    dmCategory: '分类',
    dmAllCategories: '全部分类',
    dmTotal: '共',
    dmExport: '导出 CSV',
    dmEdit: '编辑',
    dmDelete: '删除',
    dmSave: '保存',
    dmCancel: '取消',
    dmNoRecords: '暂无工作记录',
    dmColId: 'ID',
    dmColDate: '日期',
    dmColMember: '登记人',
    dmColCategory: '分类',
    dmColTask: '任务',
    dmColVolume: '处理量',
    dmColHours: '工时',
    dmColStatus: '合规状态',
    dmColNote: '备注',
    dmColActions: '操作',
    dmNoncompliant: '非标',
    dmNotePlaceholder: '备注（≤200字）',
    dmDeleteTitle: '删除工作记录',
    dmDeleteBody: '确认删除"{task}"（{date}）的工作记录？',
    dmHardDelete: '彻底删除（不可恢复）',
    dmHardDeleteWarning: '彻底删除将永久移除该记录，无法恢复。',
    dmDeleteConfirm: '确认删除',
    // Duty Schedule + Holiday Calendar (T018)
    dsHolidayCalendar: '节假日日历',
    dsImportTitle: '排班导入',
    dsImportHint: '仅解析名称为纯 YYYYMM（6位数字）的 sheet，其他 sheet 自动跳过。',
    dsImportUpload: '上传排班 Excel',
    dsImportPreview: '解析预览',
    dsImportMembers: '成员数',
    dsImportDays: '天数',
    dsImportAdded: '新增',
    dsImportOverridden: '覆盖',
    dsImportWarnings: '警告',
    dsImportConfirm: '确认导入',
    dsImportCancel: '取消',
    dsImportSuccess: '导入成功，共写入 {n} 条',
    dsImportNoRows: '无可导入的排班数据',
    dsImportColMember: '成员',
    dsImportColDate: '日期',
    dsImportColStatus: '状态',
    dsImportColAction: '动作',
    dsImportNewLabel: '新增',
    dsImportOverrideLabel: '覆盖',
    // Duty schedule grid (T019)
    dsGridTitle: '排班网格',
    dsMonthlyStatsTitle: '月度统计',
    dsGridMonth: '月份',
    dsGridLoading: '加载排班中...',
    dsGridNoData: '本月暂无排班数据',
    dsGridSaved: '已保存',
    dsGridSaveError: '保存失败',
    dsGridSelectMonth: '选择月份',
    dsGridBatchHint: '按住 Shift 点击格子可批量选中，再点击一次取消选中',
    dsGridBatchSetStatus: '批量设置状态',
    dsGridBatchApply: '应用',
    dsGridClearSelection: '清除选中',
    dsGridColMember: '成员',
    // Monthly stats columns
    dsStatsOnWorkday: '上班',
    dsStatsOnNonworkday: '值班',
    dsStatsOffWorkday: '调休',
    dsStatsOffNonworkday: '休息',
    dsStatsVacation: '休假',
    dsStatsLeave: '请假',
    dsStatsOvertime: '加班',
    dsStatsOvertimeCompOff: '加班补休',
    dsTotalOnDuty: '总在岗',
    dsStatsNoData: '本月暂无统计数据',
    // Status display labels
    dsStatusOnWorkday: '上班',
    dsStatusOnNonworkday: '值班',
    dsStatusOffWorkday: '调休',
    dsStatusOffNonworkday: '休息',
    dsStatusVacation: '休假',
    dsStatusLeaveMorning: '请假上午',
    dsStatusLeaveAfternoon: '请假下午',
    dsStatusLeaveFullDay: '请假一天',
    dsStatusOvertime: '加班',
    dsStatusOvertimeMorning: '加班上午',
    dsStatusOvertimeAfternoon: '加班下午',
    dsStatusOvertimeFullDay: '加班一天',
    dsStatusOvertimeCompOff: '加班补休',
    dsStatusLeaveSubmenu: '请假...',
    dsStatusOvertimeSubmenu: '加班...',
    // Grid cell abbreviations (CSWD-127 T001)
    dsGridAbbrOnWorkday: '上班',
    dsGridAbbrOnNonworkday: '值班',
    dsGridAbbrOffWorkday: '调休',
    dsGridAbbrOffNonworkday: '休',
    dsGridAbbrVacation: '休假',
    dsGridAbbrLeaveMorning: '假上',
    dsGridAbbrLeaveAfternoon: '假下',
    dsGridAbbrLeaveFullDay: '假',
    dsGridAbbrOvertime: '加班',
    dsGridAbbrOvertimeMorning: '加上',
    dsGridAbbrOvertimeAfternoon: '加下',
    dsGridAbbrOvertimeFullDay: '加天',
    dsGridAbbrOvertimeCompOff: '补休',
    // Weekday labels (CSWD-127 T001, grid column header)
    dsGridWeekdaySun: '周日',
    dsGridWeekdayMon: '周一',
    dsGridWeekdayTue: '周二',
    dsGridWeekdayWed: '周三',
    dsGridWeekdayThu: '周四',
    dsGridWeekdayFri: '周五',
    dsGridWeekdaySat: '周六',
    // Personal task calendar schedule indicator
    ptScheduleTooltip: '排班：{status}',
    // Holiday calendar
    holidayColDate: '日期',
    holidayColRegion: '区域',
    holidayColType: '类型',
    holidayColName: '名称',
    holidayActions: '操作',
    holidayTypeHoliday: '节假日',
    holidayTypeMakeup: '补班日',
    holidayAddEntry: '添加记录',
    holidayImportXlsx: '导入 Excel',
    holidayImportSuccess: '导入成功：已写入 {added} 条，跳过 {skipped} 条',
    holidayNoData: '暂无节假日记录',
    holidayDeleteConfirm: '确认删除该节假日记录？',
    holidayEdit: '编辑',
    holidayDelete: '删除',
    holidaySave: '保存',
    holidayCancel: '取消',
    holidaySaved: '已保存',
    holidayDeleted: '已删除',
    holidayAdded: '已添加',
    holidayRegionFilter: '按区域筛选',
    holidayRegionAll: '全部区域',
    holidayRegionCN: '中国 (CN)',
    holidayRegionUS: '美国 (US)',
    holidayNamePlaceholder: '名称（可选）',
    holidayDateRequired: '请选择日期',
    holidayTotal: '共',
    // Assignment board (T020)
    assignBoardTitle: '任务分派看板',
    assignSelectMembers: '选择成员',
    assignSelectDates: '选择日期',
    assignSelectTasks: '选择任务',
    assignCartesian: '笛卡尔积批量',
    assignCartesianSummary: '{m} 成员 × {d} 天 × {t} 任务 = {n} 条',
    assignConfirm: '确认分派',
    assignCancel: '取消',
    assignWithdraw: '撤回',
    assignWithdrawConfirm: '任务已有进度，确认撤回？',
    assignWithdrawDone: '已完成任务不可撤回',
    assignReassign: '改派',
    assignReassignTitle: '改派任务',
    assignNewAssignee: '新受派人',
    assignNewDate: '新日期',
    assignReschedule: '改期',
    assignRescheduleTitle: '改期',
    assignConflictYellow: '调休/休息/请假一天，确认分派？',
    assignConflictBlue: '请假半天，可分派',
    assignReadOnly: '只读（成员自创任务）',
    assignNoTasks: '本期无分派任务',
    assignLoading: '加载中...',
    assignSuccess: '分派成功',
    assignGhostChip: '原计划',
    assignStatusTodo: '待处理',
    assignStatusProgress: '进行中',
    assignStatusDone: '已完成',
    assignElapsed: '已用时',
    // Quarterly report
    qrTitle: '季度工作量分析报表',
    qrYear: '年份',
    qrQuarter: '季度',
    qrGenerate: '生成并下载',
    qrGenerating: '生成中...',
    qrForbidden: 'Member 无导出权限',
    qrEmptyQuarter: '该季度暂无数据，无法生成报表',
    qrCustomRanking: '附加自定义计入任务排行（额外 sheet）',
    qrSelectPreset: '选择预设',
    qrNoPreset: '（无预设）',
    qrSelectYear: '请选择年份',
    qrSelectQuarter: '请选择季度',
    // Global Search (T022)
    gsTitle: '全局工作量查询',
    gsMember: '成员',
    gsCategory: '分类',
    gsTask: '任务',
    gsRegion: '区域',
    gsCompliant: '合规状态',
    gsCompliantYes: '合规',
    gsCompliantNo: '非标',
    gsTaskStatus: '任务状态',
    gsKeyword: '关键字',
    gsKeywordPlaceholder: '搜索任务名称…',
    gsDateFrom: '开始日期',
    gsDateTo: '结束日期',
    gsDateDim: '日期维度',
    gsDateDimStart: '按开始日期',
    gsDateDimComplete: '按完成日期',
    gsAll: '全部',
    gsExport: '导出 CSV',
    gsExportError: '导出失败，请稍后重试',
    gsSearchError: '查询失败，请稍后重试',
    gsNoResults: '暂无符合条件的记录',
    gsTotal: '匹配总数',
    gsDisplaying: '显示',
    gsTruncatedWarning: '结果超过 5000 条（共 {total} 条），已显示前 5000 条。请收窄筛选条件，或通过导出获取全量数据。',
    gsStartDate: '开始日期',
    gsCompleteDate: '完成日期',
    gsMemberCol: '成员',
    gsRegionGroup: '区域/组',
    gsTaskCol: '任务',
    gsVolume: '处理量',
    gsHours: '工时',
    gsNote: '备注',
    gsTaskStatusCol: '任务状态',
    gsActions: '操作',
    gsEdit: '编辑',
    gsTotalsBar: '总计',
    gsTotalsTaskCount: '任务数量',
    gsTotalsVolume: '处理量',
    gsTotalsHours: '工时',
    // Help Panel (T005)
    helpLabel: '帮助',
    helpPanelTitle: '帮助中心',
    helpSearchPlaceholder: '搜索问题（如"榜单""导出"）…',
    helpNoMatch: '暂未收录该问题，可联系管理员',
    // Trend Analysis Page (CSWD-127 T003)
    trendForbidden: '仅 Manager 和 Admin 可访问趋势分析页',
    trendDimension: '维度',
    trendDimTask: '按任务名称',
    trendDimRegion: '按区域',
    trendTask: '任务',
    trendRegion: '区域',
    trendGranularity: '粒度',
    trendGranMonth: '按月',
    trendGranQuarter: '按季',
    trendGranYear: '按年',
    trendQuery: '查询',
    trendChartTitle: '处理件数趋势（折线图）',
    trendVolume: '处理件数',
    trendPeriod: '周期',
    trendMom: '环比',
    trendYoy: '同比',
    trendYoyInsufficient: '数据不足',
    trendNoData: '暂无趋势数据',
    // Stats Hub & Data Reports Hub (CSWD-127 T004)
    navStats: '统计分析',
    navDataReports: '数据与报表',
    statsHubTabOverview: '核心概览',
    statsHubTabRegional: '区域透视',
    statsHubTabLeaderboard: '效能榜单',
    statsHubTabTrend: '趋势分析',
    dataReportsHubTabDataMgmt: '数据管理',
    dataReportsHubTabQuarterly: '季度报表',
    // My Performance page (CSWD-130 T003)
    myPerfTitle: '个人效能看板',
    myPerfVolumeTotal: '累计处理量',
    myPerfHoursTotal: '累计投入工时',
    myPerfAvgRate: '平均产出率',
    myPerfVolumeTrend: '处理量趋势',
    myPerfCategoryBreakdown: '分类占比',
    myPerfRecentLogs: '最近工作记录',
    myPerfNoData: '暂无数据',
    myPerfHoursUnit: '小时',
    myPerfCountUnit: '件/小时',
    // Common
    loading: '加载中...',
    comingSoon: '功能即将上线',
  },
  en: {
    // App
    appTitle: 'CS Workload Dashboard',
    langToggle: '中文',
    // Font & theme chrome
    fontSizeLabel: 'Font Size',
    fontStandard: 'Standard',
    fontLarge: 'Large',
    fontXlarge: 'X-Large',
    themeLight: 'Light',
    themeGreen: 'Eye-Friendly Green',
    // Nav tabs
    navPersonalTasks: 'Personal Tasks',
    navMyPerformance: 'My Performance',
    navOverview: 'Overview',
    navRegional: 'Regional Pivot',
    navLeaderboard: 'Leaderboard',
    navDataMgmt: 'Data Management',
    navNoncompliant: 'Noncompliant',
    navAssignments: 'Assignments',
    navDutySchedule: 'Duty Schedule',
    navQuarterlyReport: 'Quarterly Report',
    navGlobalSearch: 'Global Search',
    navPersonnel: 'Personnel',
    navTaskDict: 'Task Dictionary',
    navAdminConsole: 'Admin Console',
    navAuditLog: 'Audit Log',
    // Notifications
    notifications: 'Notifications',
    notifEmpty: 'No notifications',
    notifTaskAssigned1: 'New task assigned: {title}',
    notifTaskAssignedN: '{n} new tasks assigned',
    notifTaskWithdrawn: 'Task withdrawn: {title}',
    notifTaskReassigned: 'Task reassigned: {title}',
    notifTaskOverdue: 'Task overdue: {title}',
    notifNoncompliantCreated: 'A work log became noncompliant',
    notifGeneric: 'You have a new notification',
    // Audit log
    auditFilterEntityType: 'Filter by entity type',
    auditClearFilter: 'Clear filter',
    auditTotal: 'Total',
    auditTime: 'Time',
    auditActor: 'Actor',
    auditActorRole: 'Role',
    auditAction: 'Action',
    auditEntityType: 'Entity Type',
    auditEntityId: 'Entity ID',
    auditDiff: 'Diff',
    auditNoEntries: 'No audit entries',
    // Time range
    timeRangeThisWeek: 'This Week',
    timeRangeThisMonth: 'This Month',
    timeRangeLastMonth: 'Last Month',
    timeRangeThisQuarter: 'This Quarter',
    timeRangeCustom: 'Custom',
    timeRangeFrom: 'From',
    timeRangeTo: 'To',
    // Auth
    logout: 'Logout',
    login: 'Login',
    loginTitle: 'Login',
    loginAccount: 'Email or Username',
    loginPassword: 'Password',
    loginSubmit: 'Login',
    loginRemember: 'Remember me',
    forgotPassword: 'Forgot password?',
    forgotPasswordTitle: 'Reset Password',
    forgotPasswordSubmit: 'Send Reset Email',
    forgotPasswordSent: 'If that email is registered, you will receive a reset link (valid 1 hour).',
    resetPasswordTitle: 'Set New Password',
    resetPasswordSubmit: 'Reset Password',
    resetPasswordSuccess: 'Password reset successfully. Redirecting to login…',
    backToLogin: 'Back to Login',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    oldPassword: 'Current Password',
    myAccount: 'My Account',
    basicInfo: 'Basic Info',
    displayName: 'Display Name',
    username: 'Username',
    email: 'Email',
    role: 'Role',
    region: 'Region',
    group: 'Group',
    changePassword: 'Change Password',
    saveChanges: 'Save Changes',
    profileSaved: 'Saved',
    sessions: 'Sessions',
    logoutOthers: 'Logout All Other Devices',
    logoutOthersDone: 'Other devices logged out',
    errorLoginFailed: 'Login failed. Check your credentials.',
    errorLocked: 'Account locked. Try again later or reset your password.',
    errorGeneric: 'Something went wrong. Please try again.',
    errorPasswordMismatch: 'Passwords do not match.',
    errorPasswordEmpty: 'Password cannot be empty.',
    errorInvalidResetLink: 'Invalid reset link. Please request a new one.',
    // Task Dictionary
    taskDictAddTask: 'Add Task',
    taskDictTaskName: 'Task Name',
    taskDictCountingRule: 'Counting Rule',
    taskDictReportAlias: 'Report Alias (optional)',
    taskDictIncludeInReport: 'Include in Report',
    taskDictRegionScope: 'Region Scope',
    taskDictRegionBoth: 'Both',
    taskDictRegionCnOnly: 'CN Only',
    taskDictRegionUsOnly: 'US Only',
    taskDictSoftDelete: 'Archive',
    taskDictHardDelete: 'Delete',
    taskDictEdit: 'Edit',
    taskDictSave: 'Save',
    taskDictCancel: 'Cancel',
    taskDictActive: 'Active',
    taskDictInactive: 'Inactive',
    taskDictShowInactive: 'Show Inactive',
    taskDictHardDeleteTitle: 'Delete Task',
    taskDictHardDeleteBody: 'Referenced {N} times in the last 90 days. Historical records will be marked noncompliant (red) but still counted in stats.',
    taskDictHardDeleteInput: 'Type task name to confirm',
    taskDictHardDeleteConfirm: 'Confirm Delete',
    taskDictDuplicateName: 'A task with this name already exists in this category',
    taskDictCountingRuleHint: 'Takes effect immediately; history unchanged',
    taskDictReadOnly: 'Read-only',
    // Personnel
    personnelInvite: 'Invite Member',
    personnelMembers: 'Member List',
    personnelPendingInvitations: 'Pending Invitations',
    personnelShowDeactivated: 'Show Deactivated',
    personnelGroupLead: 'Group Lead',
    personnelStatus: 'Status',
    personnelActions: 'Actions',
    personnelExpiresAt: 'Expires At',
    personnelSetLead: 'Set Lead',
    personnelUnsetLead: 'Remove Lead',
    personnelTransfer: 'Transfer',
    personnelBatchTransfer: 'Batch Transfer',
    personnelBatchTransferCount: 'Transfer {n} members to new group/region',
    personnelDeactivate: 'Deactivate',
    personnelDeactivateConfirm: 'Confirm deactivating this member? They will no longer be able to log in.',
    personnelReactivate: 'Reactivate',
    personnelReactivateConfirm: 'Confirm reactivating this member account?',
    personnelUnlock: 'Unlock',
    personnelResendInvite: 'Resend Invite',
    personnelResend: 'Resend',
    personnelRevoke: 'Revoke',
    personnelCancelAccount: 'Cancel',
    personnelCancelWarning: 'This action is irreversible. The account and its data will be permanently deleted.',
    personnelCancelNameConfirm: 'Type the display name "{name}" to confirm',
    personnelCancelReason: 'Reason',
    personnelCancelConfirm: 'Confirm Cancellation',
    personnelSetLeadWarning: '{name} is currently the group lead. Setting a new lead will remove their lead status.',
    personnelCancel: 'Cancel',
    personnelConfirm: 'Confirm',
    personnelSubmit: 'Send Invitation',
    // Activate
    activateTitle: 'Activate Account',
    activateSubtitle: 'Set your username and password to get started',
    activateUsername: 'Username',
    activateUsernamePlaceholder: '3-32 chars, letters/digits/underscore',
    activateUsernameHint: 'Username must be 3-32 characters: letters, digits, underscores only',
    activateUsernameInvalid: 'Invalid username format (3-32 chars, letters/digits/underscore)',
    activateSubmit: 'Activate Account',
    activateError: 'Activation failed. The link may have expired or already been used.',
    activateTokenMissing: 'Invalid activation link',
    activateSuccess: 'Account activated successfully. Please log in.',
    // Admin Console
    adminTabRoles: 'Role Management',
    adminTabScope: 'Visible Scope',
    adminTabSysConfig: 'System Config',
    adminInviteManager: 'Invite Manager',
    adminInviteMember: 'Invite Member',
    adminPendingMemberInvitations: 'Pending Member Invitations',
    adminMemberName: 'Name',
    adminMemberEmail: 'Email',
    adminMemberRole: 'Role',
    adminMemberGroup: 'Group',
    adminMemberStatus: 'Status',
    adminActions: 'Actions',
    adminPromote: 'Promote to Manager',
    adminDemote: 'Demote to Member',
    adminDeactivate: 'Deactivate',
    adminPromoteConfirm: 'Promote {name} to Manager?',
    adminDemoteTitle: 'Demote to Member',
    adminDemoteBody: 'Type {name}\'s display name to confirm demotion',
    adminDemoteInput: 'Display Name',
    adminDemoteConfirm: 'Confirm Demotion',
    adminDeactivateConfirm: 'Deactivate {name}? They will no longer be able to log in.',
    adminScopeTitle: 'Configure Manager Visible Scope',
    adminScopeSave: 'Save Scope',
    adminScopeAllGroups: 'All Groups (no restriction)',
    adminSysConfigTitle: 'System Configuration',
    adminSysConfigSave: 'Save Config',
    adminSysConfigAccessTtl: 'Access Token TTL (minutes)',
    adminSysConfigRefreshTtl: 'Refresh Token TTL (days)',
    adminSysConfigLockoutThreshold: 'Lockout Threshold (attempts)',
    adminSysConfigLockoutMinutes: 'Lockout Duration (minutes)',
    adminSysConfigBackupTime: 'Backup Time (HH:MM)',
    adminSysConfigRetentionDays: 'Data Retention Days',
    adminSysConfigSaved: 'Config saved',
    adminAuditLink: 'View Full Audit Log',
    adminPendingInvitations: 'Pending Invitations',
    adminNoManagers: 'No managers',
    adminNoMembers: 'No members',
    // Work Log Form (T012)
    wlFormTitle: 'Add Work Log',
    wlFormOpen: 'Log',
    wlFormCategory: 'Category',
    wlFormTask: 'Task',
    wlFormTaskCustom: 'Task Name (custom)',
    wlFormTaskPlaceholder: 'Slack and email follow-up',
    wlFormCountingRule: 'Counting rule: {rule}',
    wlFormDate: 'Date',
    wlFormVolume: 'Volume',
    wlFormHours: 'Hours (e.g. 1.5h or 90m)',
    wlFormNote: 'Note (≤200 chars)',
    wlFormRegistrant: 'Registrant',
    wlFormSubmit: 'Submit',
    wlFormCancel: 'Cancel',
    wlFormSuccess: 'Work log submitted',
    wlFormErrorAdmin: 'Admin cannot be the registrant',
    wlFormDateFuture: 'Date is more than 7 days in the future. Confirm submit?',
    wlFormDateOld: 'Date is more than 90 days ago. Confirm submit?',
    wlFormSelectTask: 'Select a task from the dictionary',
    wlFormSelectCategory: 'Select a category',
    wlFormSelectRegistrant: 'Select a registrant',
    // Overview (T013)
    overviewTotalVolume: 'Total Volume',
    overviewTotalHours: 'Total Hours',
    overviewAvgThroughput: 'Avg Throughput',
    overviewNoncompliant: 'Noncompliant Records',
    overviewTotalMembers: 'Total Members',
    overviewNoncompliantUnit: 'records',
    overviewNoncompliantHint: 'Click to view details',
    overviewDonutTitle: 'Volume by Category',
    overviewBarTitle: 'CN/US Messages & Hours',
    overviewBarMessages: 'Messages',
    overviewBarHours: 'Hours',
    overviewForbidden: 'Only Manager and Admin can access the overview page',
    overviewNoData: 'No data',
    // Regional Pivot (T014)
    regionalBarTitle: 'Volume by Group (Stacked by Category)',
    regionalCNTitle: 'China (CN) Members',
    regionalUSTitle: 'United States (US) Members',
    regionalMember: 'Member',
    regionalVolume: 'Volume',
    regionalHours: 'Hours',
    regionalThroughput: 'Throughput',
    regionalTotal: 'Total',
    regionalForbidden: 'Only Manager and Admin can access the regional pivot page',
    regionalNoData: 'No data',
    // Noncompliant Records (T015)
    noncompliantForbidden: 'Only Manager and Admin can access the noncompliant records page',
    noncompliantRegionFilter: 'Region',
    noncompliantRegionAll: 'All Regions',
    noncompliantInfoBanner: 'This view lists noncompliant records (read-only) produced by hard-deleting a task. Noncompliant record volumes still count toward throughput statistics.',
    noncompliantTotal: 'Total',
    noncompliantNoRecords: 'No noncompliant records',
    noncompliantColDate: 'Date',
    noncompliantColMember: 'Registrant',
    noncompliantColRegion: 'Region',
    noncompliantColGroup: 'Group',
    noncompliantColCategory: 'Category',
    noncompliantColTask: 'Task',
    noncompliantColVolume: 'Volume',
    noncompliantColHours: 'Hours',
    noncompliantColNote: 'Note',
    noncompliantColStatus: 'Status',
    noncompliantStatusLabel: 'Noncompliant',
    // Leaderboard (T016)
    leaderboardForbidden: 'Only Manager and Admin can access the leaderboard',
    leaderboardTaskFilter: 'Task Filter',
    leaderboardPresets: 'Presets',
    leaderboardNoData: 'No leaderboard data',
    leaderboardColRank: 'Rank',
    leaderboardColMember: 'Member',
    leaderboardColRegion: 'Region',
    leaderboardColGroup: 'Group',
    leaderboardColVolume: 'Volume',
    leaderboardColHours: 'Hours',
    leaderboardColRecords: 'Records',
    leaderboardGroupLead: 'Group Lead',
    leaderboardTasksIncluded: 'tasks',
    leaderboardSelectAll: 'Select All',
    leaderboardDeselectAll: 'Deselect All',
    leaderboardPresetSave: 'Save Preset',
    leaderboardPresetSaved: 'Preset saved',
    leaderboardPresetLoad: 'Apply',
    leaderboardPresetDelete: 'Delete',
    leaderboardPresetDeleteConfirm: 'Delete this preset?',
    leaderboardNoPresets: 'No presets yet',
    leaderboardPresetNamePlaceholder: 'Preset name',
    // Data Management (T017)
    dmForbidden: 'Only Manager and Admin can access Data Management',
    dmKeyword: 'Keyword',
    dmKeywordPlaceholder: 'Search task name...',
    dmKeywordActive: 'Keyword',
    dmSearch: 'Search',
    dmRegistrant: 'Registrant',
    dmAllMembers: 'All Registrants',
    dmCategory: 'Category',
    dmAllCategories: 'All Categories',
    dmTotal: 'Total',
    dmExport: 'Export CSV',
    dmEdit: 'Edit',
    dmDelete: 'Delete',
    dmSave: 'Save',
    dmCancel: 'Cancel',
    dmNoRecords: 'No work logs',
    dmColId: 'ID',
    dmColDate: 'Date',
    dmColMember: 'Registrant',
    dmColCategory: 'Category',
    dmColTask: 'Task',
    dmColVolume: 'Volume',
    dmColHours: 'Hours',
    dmColStatus: 'Status',
    dmColNote: 'Note',
    dmColActions: 'Actions',
    dmNoncompliant: 'Noncompliant',
    dmNotePlaceholder: 'Note (≤200 chars)',
    dmDeleteTitle: 'Delete Work Log',
    dmDeleteBody: 'Delete "{task}" ({date})?',
    dmHardDelete: 'Permanently delete (irreversible)',
    dmHardDeleteWarning: 'Permanent deletion removes the record entirely and cannot be undone.',
    dmDeleteConfirm: 'Confirm Delete',
    // Duty Schedule + Holiday Calendar (T018)
    dsHolidayCalendar: 'Holiday Calendar',
    dsImportTitle: 'Schedule Import',
    dsImportHint: 'Only sheets named purely as YYYYMM (6 digits) are parsed; all other sheets are skipped.',
    dsImportUpload: 'Upload Schedule Excel',
    dsImportPreview: 'Parse Preview',
    dsImportMembers: 'Members',
    dsImportDays: 'Days',
    dsImportAdded: 'Added',
    dsImportOverridden: 'Overridden',
    dsImportWarnings: 'Warnings',
    dsImportConfirm: 'Confirm Import',
    dsImportCancel: 'Cancel',
    dsImportSuccess: 'Import successful — {n} records written',
    dsImportNoRows: 'No importable schedule rows',
    dsImportColMember: 'Member',
    dsImportColDate: 'Date',
    dsImportColStatus: 'Status',
    dsImportColAction: 'Action',
    dsImportNewLabel: 'New',
    dsImportOverrideLabel: 'Override',
    // Duty schedule grid (T019)
    dsGridTitle: 'Schedule Grid',
    dsMonthlyStatsTitle: 'Monthly Stats',
    dsGridMonth: 'Month',
    dsGridLoading: 'Loading schedule...',
    dsGridNoData: 'No schedule data for this month',
    dsGridSaved: 'Saved',
    dsGridSaveError: 'Save failed',
    dsGridSelectMonth: 'Select month',
    dsGridBatchHint: 'Hold Shift and click cells to multi-select, click again to deselect',
    dsGridBatchSetStatus: 'Set status for selected',
    dsGridBatchApply: 'Apply',
    dsGridClearSelection: 'Clear selection',
    dsGridColMember: 'Member',
    // Monthly stats columns
    dsStatsOnWorkday: 'Workday',
    dsStatsOnNonworkday: 'Non-workday duty',
    dsStatsOffWorkday: 'Comp off',
    dsStatsOffNonworkday: 'Day off',
    dsStatsVacation: 'Vacation',
    dsStatsLeave: 'Leave',
    dsStatsOvertime: 'Overtime',
    dsStatsOvertimeCompOff: 'OT comp off',
    dsTotalOnDuty: 'Total on duty',
    dsStatsNoData: 'No stats for this month',
    // Status display labels
    dsStatusOnWorkday: 'Work',
    dsStatusOnNonworkday: 'On duty',
    dsStatusOffWorkday: 'Comp off',
    dsStatusOffNonworkday: 'Day off',
    dsStatusVacation: 'Vacation',
    dsStatusLeaveMorning: 'Leave AM',
    dsStatusLeaveAfternoon: 'Leave PM',
    dsStatusLeaveFullDay: 'Leave (full)',
    dsStatusOvertime: 'OT',
    dsStatusOvertimeMorning: 'OT AM',
    dsStatusOvertimeAfternoon: 'OT PM',
    dsStatusOvertimeFullDay: 'OT (full)',
    dsStatusOvertimeCompOff: 'OT comp',
    dsStatusLeaveSubmenu: 'Leave...',
    dsStatusOvertimeSubmenu: 'Overtime...',
    // Grid cell abbreviations (CSWD-127 T001)
    dsGridAbbrOnWorkday: 'Work',
    dsGridAbbrOnNonworkday: 'Duty',
    dsGridAbbrOffWorkday: 'CompOff',
    dsGridAbbrOffNonworkday: 'Off',
    dsGridAbbrVacation: 'Vac',
    dsGridAbbrLeaveMorning: 'Lv AM',
    dsGridAbbrLeaveAfternoon: 'Lv PM',
    dsGridAbbrLeaveFullDay: 'Leave',
    dsGridAbbrOvertime: 'OT',
    dsGridAbbrOvertimeMorning: 'OT AM',
    dsGridAbbrOvertimeAfternoon: 'OT PM',
    dsGridAbbrOvertimeFullDay: 'OT+',
    dsGridAbbrOvertimeCompOff: 'OT Co',
    // Weekday labels (CSWD-127 T001, grid column header)
    dsGridWeekdaySun: 'Sun',
    dsGridWeekdayMon: 'Mon',
    dsGridWeekdayTue: 'Tue',
    dsGridWeekdayWed: 'Wed',
    dsGridWeekdayThu: 'Thu',
    dsGridWeekdayFri: 'Fri',
    dsGridWeekdaySat: 'Sat',
    // Personal task calendar schedule indicator
    ptScheduleTooltip: 'Schedule: {status}',
    // Holiday calendar
    holidayColDate: 'Date',
    holidayColRegion: 'Region',
    holidayColType: 'Type',
    holidayColName: 'Name',
    holidayActions: 'Actions',
    holidayTypeHoliday: 'Holiday',
    holidayTypeMakeup: 'Makeup Workday',
    holidayAddEntry: 'Add Entry',
    holidayImportXlsx: 'Import Excel',
    holidayImportSuccess: 'Import complete: {added} upserted, {skipped} skipped',
    holidayNoData: 'No holiday records',
    holidayDeleteConfirm: 'Delete this holiday entry?',
    holidayEdit: 'Edit',
    holidayDelete: 'Delete',
    holidaySave: 'Save',
    holidayCancel: 'Cancel',
    holidaySaved: 'Saved',
    holidayDeleted: 'Deleted',
    holidayAdded: 'Added',
    holidayRegionFilter: 'Filter by region',
    holidayRegionAll: 'All Regions',
    holidayRegionCN: 'China (CN)',
    holidayRegionUS: 'United States (US)',
    holidayNamePlaceholder: 'Name (optional)',
    holidayDateRequired: 'Please select a date',
    holidayTotal: 'Total',
    // Assignment board (T020)
    assignBoardTitle: 'Assignment Board',
    assignSelectMembers: 'Select Members',
    assignSelectDates: 'Select Dates',
    assignSelectTasks: 'Select Tasks',
    assignCartesian: 'Cartesian Batch',
    assignCartesianSummary: '{m} members × {d} days × {t} tasks = {n} items',
    assignConfirm: 'Confirm Assignment',
    assignCancel: 'Cancel',
    assignWithdraw: 'Withdraw',
    assignWithdrawConfirm: 'Task has progress. Confirm withdraw?',
    assignWithdrawDone: 'Completed tasks cannot be withdrawn',
    assignReassign: 'Reassign',
    assignReassignTitle: 'Reassign Task',
    assignNewAssignee: 'New Assignee',
    assignNewDate: 'New Date',
    assignReschedule: 'Reschedule',
    assignRescheduleTitle: 'Reschedule',
    assignConflictYellow: 'Off/leave day — confirm assignment?',
    assignConflictBlue: 'Half-day leave — can assign',
    assignReadOnly: 'Read-only (member self-created)',
    assignNoTasks: 'No assigned tasks in this period',
    assignLoading: 'Loading...',
    assignSuccess: 'Assignment successful',
    assignGhostChip: 'Original',
    assignStatusTodo: 'Todo',
    assignStatusProgress: 'In progress',
    assignStatusDone: 'Done',
    assignElapsed: 'Elapsed',
    // Quarterly report
    qrTitle: 'Quarterly Workload Analysis Report',
    qrYear: 'Year',
    qrQuarter: 'Quarter',
    qrGenerate: 'Generate & Download',
    qrGenerating: 'Generating...',
    qrForbidden: 'Members do not have export access',
    qrEmptyQuarter: 'No data for this quarter, cannot generate report',
    qrCustomRanking: 'Include custom task ranking (extra sheet)',
    qrSelectPreset: 'Select preset',
    qrNoPreset: '(no preset)',
    qrSelectYear: 'Select year',
    qrSelectQuarter: 'Select quarter',
    // Global Search (T022)
    gsTitle: 'Global Workload Search',
    gsMember: 'Member',
    gsCategory: 'Category',
    gsTask: 'Task',
    gsRegion: 'Region',
    gsCompliant: 'Compliant',
    gsCompliantYes: 'Compliant',
    gsCompliantNo: 'Non-compliant',
    gsTaskStatus: 'Task Status',
    gsKeyword: 'Keyword',
    gsKeywordPlaceholder: 'Search task name…',
    gsDateFrom: 'Date From',
    gsDateTo: 'Date To',
    gsDateDim: 'Date Dimension',
    gsDateDimStart: 'By Start Date',
    gsDateDimComplete: 'By Complete Date',
    gsAll: 'All',
    gsExport: 'Export CSV',
    gsExportError: 'Export failed, please try again',
    gsSearchError: 'Search failed, please try again',
    gsNoResults: 'No records found',
    gsTotal: 'Total matches',
    gsDisplaying: 'Displaying',
    gsTruncatedWarning: 'Results exceed 5,000 rows (total {total}). Showing first 5,000. Narrow your filters or use Export for full data.',
    gsStartDate: 'Start Date',
    gsCompleteDate: 'Complete Date',
    gsMemberCol: 'Member',
    gsRegionGroup: 'Region/Group',
    gsTaskCol: 'Task',
    gsVolume: 'Volume',
    gsHours: 'Hours',
    gsNote: 'Note',
    gsTaskStatusCol: 'Task Status',
    gsActions: 'Actions',
    gsEdit: 'Edit',
    gsTotalsBar: 'Totals',
    gsTotalsTaskCount: 'Task Count',
    gsTotalsVolume: 'Volume',
    gsTotalsHours: 'Hours',
    // Help Panel (T005)
    helpLabel: 'Help',
    helpPanelTitle: 'Help Center',
    helpSearchPlaceholder: 'Search (e.g. "leaderboard", "export")…',
    helpNoMatch: 'No matching topics found. Please contact your administrator.',
    // Trend Analysis Page (CSWD-127 T003)
    trendForbidden: 'Only Manager and Admin can access the trend analysis page',
    trendDimension: 'Dimension',
    trendDimTask: 'By Task',
    trendDimRegion: 'By Region',
    trendTask: 'Task',
    trendRegion: 'Region',
    trendGranularity: 'Granularity',
    trendGranMonth: 'Monthly',
    trendGranQuarter: 'Quarterly',
    trendGranYear: 'Yearly',
    trendQuery: 'Query',
    trendChartTitle: 'Volume Trend (Line Chart)',
    trendVolume: 'Volume',
    trendPeriod: 'Period',
    trendMom: 'MoM',
    trendYoy: 'YoY',
    trendYoyInsufficient: 'Insufficient data',
    trendNoData: 'No trend data',
    // Stats Hub & Data Reports Hub (CSWD-127 T004)
    navStats: 'Stats & Analysis',
    navDataReports: 'Data & Reports',
    statsHubTabOverview: 'Overview',
    statsHubTabRegional: 'Regional',
    statsHubTabLeaderboard: 'Leaderboard',
    statsHubTabTrend: 'Trends',
    dataReportsHubTabDataMgmt: 'Data Management',
    dataReportsHubTabQuarterly: 'Quarterly Report',
    // My Performance page (CSWD-130 T003)
    myPerfTitle: 'My Performance',
    myPerfVolumeTotal: 'Total Volume',
    myPerfHoursTotal: 'Total Hours',
    myPerfAvgRate: 'Avg Output Rate',
    myPerfVolumeTrend: 'Volume Trend',
    myPerfCategoryBreakdown: 'Category Breakdown',
    myPerfRecentLogs: 'Recent Work Logs',
    myPerfNoData: 'No data',
    myPerfHoursUnit: 'hrs',
    myPerfCountUnit: 'items/hr',
    // Common
    loading: 'Loading...',
    comingSoon: 'Coming soon',
  },
}

interface LangContextValue {
  lang: Lang
  setLang: (lang: Lang) => void
  t: (key: string) => string
}

const LangContext = createContext<LangContextValue | null>(null)

const STORAGE_KEY = 'cswd_lang'

export function LangProvider({ children }: { children: React.ReactNode }) {
  const [lang, setLangState] = useState<Lang>(() => {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored === 'en' ? 'en' : 'zh'
  })

  const setLang = (newLang: Lang) => {
    setLangState(newLang)
    localStorage.setItem(STORAGE_KEY, newLang)
  }

  const t = (key: string): string => {
    return strings[lang][key] ?? key
  }

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  )
}

export function useLang(): LangContextValue {
  const ctx = useContext(LangContext)
  if (ctx === null) {
    throw new Error('useLang must be used within a LangProvider')
  }
  return ctx
}
